import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";
import AppContainer from "./AppContainer";
import reducer from "./reducers";
import { userLogin, userLogout } from "./actions";
import { unregister } from "./registerServiceWorker";

import "./index.css";

const CustomEvent = require("custom-event");

const store = createStore(
  reducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

window.wrapperContainer = document.getElementsByClassName("wrapper")[0];

function masterResize(height = false) {}

window.masterResize = masterResize;

function updateMinHeight(minHeight) {
  if (window.wrapperContainer) {
    window.wrapperContainer.style.minHeight = `calc(${minHeight} - 6.4rem)`;
  }
}

function hookup() {
  // create event for user login from parent
  window.addEventListener("userlogin", event =>
    store.dispatch(userLogin(event))
  );
  // create event for user logout from parent
  window.addEventListener("userlogout", () => store.dispatch(userLogout()));
  // create event for min height adjustment
  window.addEventListener("updateMinHeight", event =>
    updateMinHeight(event.detail.minHeight)
  );

  window.parentResize = function(width, height) {
    console.log("parentResize", width, height);

    if (window.parent.gsntvFrameResize) {
      console.log("gsntvFrameResize");

      window.parent.gsntvFrameResize(width, height);
    }
  };

  window.gsntvLoginFromParent = function(data) {
    console.log("gsntvLoginFromParent", data);

    window.dispatchEvent(
      new CustomEvent("userlogin", {
        detail: data,
        bubbles: false,
        cancelable: false
      })
    );
  };

  window.gsntvLogoutFromParent = function() {
    console.log("gsntvLogoutFromParent");

    window.dispatchEvent(new CustomEvent("userlogout"));
  };

  window.gsntvUpdateMinHeight = function(minHeight) {
    console.log("gsntvUpdateMinHeight");

    // var wrapper = document.getElementsByClassName("wrapper")[0];
    // wrapper.style.minHeight = "calc(" + minHeight + " - 6.4rem)";
  };
}

hookup();

ReactDOM.render(
  <Provider store={store}>
    <AppContainer />
  </Provider>,
  document.getElementById("root")
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js